// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__xbKNs","pink":"About_pink__xFNwP","green":"About_green__4Juwy","skills":"About_skills__AXmTq"};